export const parseNonNegativeWholeNumber = (
  value: any,
  fallback: number = 3
): number => {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  if (!Number.isInteger(num)) return fallback;
  if (num < 0) return fallback;
  return num;
};
